import React from 'react'
import {Spacer} from '../../../Common/Components/Spacer'
import {MBContentSubTitleTypography} from '../Atoms/Typographies'
import {BucketInfo} from '../../DTO/BucketInfoDTO'
import {MembersPageTemplate} from '../Molecules/BaseMembersPages/MembersPageTemplate'
import {PageTitle} from '../Molecules/BaseMembersPages/PageTitle'
import {ContentBlock} from '../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../Molecules/BaseContentBlocks/ContentTitle'
import {ExternalLinkButton} from '../Atoms/Buttons'
import {PIMPageActions} from '../Atoms/Layouts/PIMPageActions'

type LeavingMessageContentProps = {
  pageTitle: string
  bucketInfo?: Omit<BucketInfo, 'mailMagazineList'>
}

export const LeavingMessageContent: React.VFC<LeavingMessageContentProps> = (props) => {
  return (
    <MembersPageTemplate
      hideFooterNavi={true}
      bucketInfo={props.bucketInfo}
    >
      <PageTitle>{props.pageTitle}</PageTitle>

      <ContentBlock>
        <ContentTitle noMarginBottom={true}>退会手続き済み</ContentTitle>
        <Spacer mt={'24px'} mb={'16px'}>
          <MBContentSubTitleTypography>
            退会手続き済みです。<br/>
            退会の取り消しはできません。<br/>
            現在の契約が満了後、再度入会のお手続きをしてください。
          </MBContentSubTitleTypography>
        </Spacer>
      </ContentBlock>

      <Spacer mt={'30px'}>
        <PIMPageActions>
          <ExternalLinkButton
            label={`${props.bucketInfo?.fcMyPageInfo?.name ?? ''}に移動する`}
            url={props.bucketInfo?.fcMyPageInfo?.url}
          />
        </PIMPageActions>
      </Spacer>
    </MembersPageTemplate>
  )
}
